import React, { useState, useEffect } from "react";

const AnimatedDots = () => {
  const [dots, setDots] = useState(".");

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots.length === 3 ? "." : prevDots + "."));
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return <span>Registrandose{dots}</span>;
};

export default AnimatedDots;
